import React from 'react';
import styles from '../assets/css/Transaction.module.css'; // Import the SAME CSS module

const Table = ({ data, purpose }) => {
  // Destructure data with defaults
  const {
      description = "N/A",
      date = "",
      time = "",
      add_amount = "0",
      purpose: apiPurpose = "" // Rename incoming prop to avoid conflict
  } = data || {};

  // Basic check for credit/debit based on keywords or API purpose field
  const creditKeywords = ["added", "credited", "received", "deposited", "kabad cancel", "earned", "withdrawal request has been rejected", "recharge successful"];
  let isCredit = apiPurpose === 'credit' || creditKeywords.some(keyword => description.toLowerCase().includes(keyword.toLowerCase()));

  // Specific override for withdrawal success (should be debit)
  if (description.toLowerCase().includes("withdrawal request has been approved")) {
      isCredit = false;
  }
   // Specific override for bet placed (should be debit)
   if (description.toLowerCase().includes("bet placed")) {
    isCredit = false;
  }


  // Don't render if amount is 0 (kept from original logic)
  if (add_amount === "0" || !add_amount) {
    return null;
  }

  // Specific filter for 'win' history type (kept from original logic)
  if (purpose === "win" && !description.toLowerCase().includes("earned")) {
    return null;
  }

  // Format date and time together
  const formattedDateTime = `${date || ''} ${time || ''}`.trim();

  return (
    // Use the card style defined in AghoriTransaction.module.css
    <div className={styles.historyCard}>
      <div className={styles.cardRow}>
        <span className={styles.description}>{description}</span>
        <span className={`${styles.amount} ${isCredit ? styles.credit : styles.debit}`}>
          {isCredit ? "+" : "-"}₹{add_amount}
        </span>
      </div>
      <div className={styles.cardRow}>
        <span className={styles.dateTime}>{formattedDateTime || 'N/A'}</span>
         {/* Placeholder to maintain alignment with MarketTable */}
        <span className={styles.statusPlaceholder}></span>
      </div>
    </div>
  );
};

export default Table;
